var urlParams = new URLSearchParams(window.location.search);
var orderId = urlParams.get('order_id');
var orderContainer = document.querySelector('#orderInner');

// Check for form success parameters
var formSuccessType = null;
if (urlParams.get('complaint_form_success') === 'true') {
  formSuccessType = 'complaint';
} else if (urlParams.get('message_form_success') === 'true') {
  formSuccessType = 'message';
} else if (urlParams.get('change_form_success') === 'true') {
  formSuccessType = 'change';
}

// Clean the URL if there's a success parameter
if (formSuccessType) {
  window.history.replaceState({}, document.title, window.location.pathname + '?order_id=' + orderId);
}

/**
 * Updates the return_to hidden fields in forms to include the current order_id
 * This is necessary because Liquid renders before JavaScript adds query params
 */
function updateFormReturnUrls() {
  const baseUrl = window.location.pathname + '?order_id=' + orderId;

  const formConfigs = [
    { formId: 'change-form', successParam: 'change_form_success' },
    { formId: 'complaint-form-order', successParam: 'complaint_form_success' },
    { formId: 'message-form', successParam: 'message_form_success' }
  ];

  formConfigs.forEach(config => {
    const form = document.getElementById(config.formId);
    if (form) {
      // Find the return_to hidden input (Shopify creates this)
      let returnToInput = form.querySelector('input[name="return_to"]');
      if (returnToInput) {
        returnToInput.value = baseUrl + '&' + config.successParam + '=true';
      }
    }
  });
}

function formatMoney(amount, currency = 'USD', locale = 'en-US') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(parseFloat(amount));
}

function renderOrderInfo(order) {
  // Clear the container first
  orderContainer.innerHTML = '';

  var newDiv = document.createElement('div');
  var orderDate = new Date(order.createdAt);
  var formattedDate = orderDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  // Get all unique vendors from line items (like orders.liquid does)
  var vendorSet = new Set();
  var vendorData = {}; // Store vendor info including sales rep data

  order.lineItems.edges.forEach(item => {
    var vendor = item.node.vendor || item.node.product?.vendor;

    if (vendor) {
      vendorSet.add(vendor);

      // Extract sales rep info from brand metaobject if not already stored
      if (!vendorData[vendor] && item.node.product?.metafield?.reference?.fields) {
        const fields = item.node.product.metafield.reference.fields;
        const salesRep = fields.find(f => f.key === 'sales_rep')?.value;
        const email = fields.find(f => f.key === 'email')?.value;
        const phone = fields.find(f => f.key === 'phone')?.value;

        vendorData[vendor] = {
          salesRep: salesRep || 'N/A',
          email: email || 'N/A',
          phone: phone || 'N/A'
        };
      }
    }
  });
  var vendors = Array.from(vendorSet);

  newDiv.innerHTML = `
    <div class="w-full page-width !mt-16 mb-16">
        <!-- Back Button -->
        <div class="mb-6">
            <a href="/pages/orders" class="text-dark-gray flex items-center gap-3 hover:text-black transition-colors text-[14px] md:text-[16px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17" fill="none">
                  <path d="M8.88012 16.3087C8.95688 16.3846 9 16.4876 9 16.595C9 16.7024 8.95688 16.8054 8.88012 16.8814C8.80336 16.9573 8.69926 17 8.59071 17C8.48215 17 8.37805 16.9573 8.30129 16.8814L0.119973 8.78636C0.0819396 8.74877 0.0517671 8.70413 0.0311812 8.655C0.0105952 8.60586 0 8.55319 0 8.5C0 8.44681 0.0105952 8.39414 0.0311812 8.345C0.0517671 8.29587 0.0819396 8.25123 0.119973 8.21364L8.30129 0.118615C8.3393 0.081009 8.38442 0.0511788 8.43408 0.0308268C8.48373 0.0104748 8.53696 1.04835e-09 8.59071 0C8.64445 -1.04835e-09 8.69768 0.0104748 8.74734 0.0308268C8.79699 0.0511788 8.84211 0.0810091 8.88012 0.118615C8.91813 0.15622 8.94827 0.200864 8.96884 0.249998C8.98941 0.299132 9 0.351794 9 0.404976C9 0.458158 8.98941 0.51082 8.96884 0.559954C8.94827 0.609088 8.91813 0.653732 8.88012 0.691338L0.988216 8.5L8.88012 16.3087Z" fill="#767676"/>
                </svg>
                <span class="ml-1">Back</span>
            </a>
        </div>

        <!-- Order Header -->
        <div class="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-5 gap-6">
            <div class="flex items-center gap-4 flex-wrap">
                <h1 class="scroll-trigger animate--fade-in">Order ${order.name}</h1>
                
                ${order.fulfillments.length > 0 ? `
                    ${order.fulfillments[0].status === 'CANCELLED' ? `<span class="bg-copper text-white px-5 py-2.5 rounded-full text-[10px] font-normal uppercase leading-[115%] tracking-[1.2px]">Cancelled</span>` : ''}
                    ${order.fulfillments[0].status === 'IN_PROGRESS' || order.fulfillments[0].status === 'OPEN' ? `<span class="bg-green text-white px-5 py-2.5 rounded-full text-[10px] font-normal uppercase leading-[115%] tracking-[1.2px]">In Progress</span>` : ''}
                    ${order.fulfillments[0].status === 'SUCCESS' ? `<span class="bg-navy text-white px-5 py-2.5 rounded-full text-[10px] font-normal uppercase leading-[115%] tracking-[1.2px]">Delivered</span>` : ''}
                ` : `<span class="bg-green text-white px-5 py-2.5 rounded-full text-[10px] font-normal uppercase leading-[115%] tracking-[1.2px]">Processing</span>`}
            </div>
            
            <div class="flex gap-3">
                <button data-form-trigger="change" class="bg-black border border-black px-6 py-3 text-white duration-300 transition-colors hover:bg-transparent hover:text-black whitespace-nowrap cursor-pointer text-[14px]">Change Order</button>
                <button data-form-trigger="complaint" class="bg-transparent border border-black px-6 py-3 text-black duration-300 transition-colors hover:bg-black hover:text-white whitespace-nowrap cursor-pointer text-[14px]">Report an Issue</button>
            </div>
        </div>

        <!-- Order Meta -->
        <div class="flex gap-4 items-center mb-16 flex-wrap text-[15px] md:text-[16px] leading-relaxed" style="color: #4c4c4c;">
            <span>Order placed on ${formattedDate}</span>
            ${order.poNumber ? `
                <span class="text-medium-gray">|</span>
                <span>PO: ${order.poNumber}</span>
            ` : ''}
            ${order.fulfillments.length > 0 ? `
                <span class="text-medium-gray">|</span>
                <span>Tracking: ${order.fulfillments.map(item =>
                    item.trackingInfo.map(tracking =>
                        `<a href="${tracking.url}" class="underline font-medium hover:text-copper transition-colors">${tracking.number}</a>`
                    ).join(', ')
                ).join(' ')}</span>
            ` : ''}
        </div>

        <!-- Order Details Section -->
        <div>
            <div class="mb-10">
                <h2 class="card__heading text-5xl">Order Details</h2>
            </div>
             
            <div class="flex flex-col lg:flex-row gap-10">
                <!-- Order Items Table -->
                <div class="w-full">
                    <table class="w-full bg-off-white text-[14px] md:text-[16px] leading-relaxed">
                        <thead>  
                            <tr class="border-b border-medium-gray/50">
                                <th class="p-6 text-left font-medium text-[14px]">Product</th>
                                <th class="p-6 text-left font-medium text-[14px]">SKU</th>
                                <th class="p-6 text-left font-medium text-[14px]">Price</th>
                                <th class="p-6 text-left font-medium text-[14px]">Quantity</th>
                                <th class="p-6 text-right font-medium text-[14px]">Total</th>
                            </tr>
                        </thead>
                        <tbody>

                        ${order.lineItems.edges.map(item => `
                          <tr class="border-b border-medium-gray/50">
                                <td class="p-6">${item.node.title}</td>
                                <td class="p-6">${item.node.sku}</td>
                                <td class="p-6">${formatMoney(item.node.originalUnitPriceSet.shopMoney.amount, currency = item.node.discountedTotalSet.shopMoney.currencyCode, locale = 'en-US')}</td>
                                <td class="p-6">${item.node.quantity}</td>
                                <td class="p-6 text-right">${formatMoney(item.node.discountedTotalSet.shopMoney.amount, currency = item.node.discountedTotalSet.shopMoney.currencyCode, locale = 'en-US')}</td>
                            </tr>`).join('')}
                        </tbody>
                    </table>
                    
                    <!-- Subtotal Section -->
                    <div class="border-t border-medium-gray/50 flex flex-col bg-off-white p-6 gap-5">
                        <div class="flex justify-between items-center text-[14px] md:text-[16px]">
                            <span>Subtotal</span>
                            <span>${formatMoney(order.currentSubtotalPriceSet.shopMoney.amount, currency = order.currentSubtotalPriceSet.shopMoney.currencyCode, locale = 'en-US')}</span>
                        </div>
                        <div class="flex justify-between items-center text-[14px] md:text-[16px]">
                            <span>Shipping${order.shippingLine ? ` (${order.shippingLine})` : ' (Standard)'}</span>
                            <span>${formatMoney(order.totalShippingPriceSet.shopMoney.amount, currency = order.totalShippingPriceSet.shopMoney.currencyCode, locale = 'en-US')}</span>
                        </div>
                        <div class="flex justify-between items-center font-medium text-[16px] md:text-[18px]">
                            <span>Total</span>
                            <span>${formatMoney(order.currentTotalPriceSet.shopMoney.amount, currency = order.currentSubtotalPriceSet.shopMoney.currencyCode, locale = 'en-US')}</span>
                        </div>
                    </div>
                </div>

                <!-- Right Side - Contact Info -->
                <div class="w-full lg:w-1/4 flex flex-col gap-6 shrink-0">
                    <!-- Sales Rep Cards - One per brand -->
                    <div>
                    ${vendors.map(vendor => {
                      const vendorInitial = vendor.charAt(0).toUpperCase();
                      const repData = vendorData[vendor] || {};
                      const salesRepName = repData.salesRep || null;
                      const salesRepEmail = repData.email || null;
                      const salesRepPhone = repData.phone || null;
                      
                      // Only show card if we have at least some sales rep data
                      if (!salesRepName && !salesRepEmail && !salesRepPhone) {
                        return '';
                      }
                      
                      return `
                    <div class="bg-off-white p-6">
                        <div class="flex items-center gap-4">
                            <div class="bg-black text-white rounded-full flex items-center justify-center font-medium w-12 h-12 text-[18px]">${vendorInitial}</div>
                            <span class="font-medium text-[18px] md:text-[20px] leading-[1.2] tracking-[-0.4px]">${vendor}</span>
                        </div>
                        
                        <!-- Hidden: Sales Rep, Email, Phone, Send a Message -->
                        <div class="hidden flex gap-6 mt-6 mb-6">
                            <div class="flex-1">
                                <p class="text-dark-gray uppercase text-[10px] font-medium tracking-[1.2px] mb-2">Sales Rep</p>
                                <p class="text-[14px] md:text-[16px] leading-relaxed">${salesRepName || 'N/A'}</p>
                            </div>
                            <div class="flex-1">
                                <p class="text-dark-gray uppercase text-[10px] font-medium tracking-[1.2px] mb-2">Email</p>
                                <p class="break-all text-[14px] md:text-[16px] leading-relaxed">${salesRepEmail || 'N/A'}</p>
                            </div>
                        </div>
                        
                        <div class="hidden mb-6">
                            <p class="text-dark-gray uppercase text-[10px] font-medium tracking-[1.2px] mb-2">Phone</p>
                            <p class="text-[14px] md:text-[16px] leading-relaxed">${salesRepPhone || 'N/A'}</p>
                        </div>
                        
                        <button data-form-trigger="message" class="hidden bg-transparent border w-full text-center border-black px-6 py-3 text-black duration-300 transition-colors hover:bg-black hover:text-white whitespace-nowrap cursor-pointer text-[14px]">Send a Message</button>
                    </div>
                      `;
                    }).join('')}
                    </div>

                    ${order.shippingAddress ? 
                   `
                    <!-- Shipping Address Card -->
                    <div class="bg-off-white">
                        <div class="border-b border-medium-gray/50 px-6 py-4">
                            <h3 class="font-medium text-[14px]">Shipping Address</h3>
                        </div>
                        <div class="px-6 py-5 text-[14px] md:text-[16px] leading-relaxed">
                            <p class="mb-1">${order.shippingAddress.name}</p>
                            <p class="mb-1">${order.shippingAddress.address1}</p>
                            ${order.shippingAddress.address2 ? `<p class="mb-1">${order.shippingAddress.address2}</p>` : ''}
                            <p class="mb-1">${order.shippingAddress.city}, ${order.shippingAddress.provinceCode} ${order.shippingAddress.zip}</p>
                            ${order.shippingAddress.phone ? `<p>${order.shippingAddress.phone}</p>` : ''}
                        </div>
                    </div>`
                    : ''
                    }

                    ${order.billingAddress ? `
                    <!-- Billing Address Card -->
                    <div class="bg-off-white">
                        <div class="border-b border-medium-gray/50 px-6 py-4">
                            <h3 class="font-medium text-[14px]">Billing Address</h3>
                        </div>
                        <div class="px-6 py-5 text-[14px] md:text-[16px] leading-relaxed">
                            <p class="mb-1">${order.billingAddress.name}</p>
                            <p class="mb-1">${order.billingAddress.address1}</p>
                            ${order.billingAddress.address2 ? `<p class="mb-1">${order.billingAddress.address2}</p>` : ''}
                            <p class="mb-1">${order.billingAddress.city}, ${order.billingAddress.provinceCode} ${order.billingAddress.zip}</p>
                            ${order.billingAddress.phone ? `<p>${order.billingAddress.phone}</p>` : ''}
                        </div>
                    </div>
                    `
                    : ''}
                </div>
            </div>
        </div>
    </div>
  `
  orderContainer.appendChild(newDiv);

  renderpopups();

  let allOrderInputs = document.querySelectorAll('[data-order-number]');

  allOrderInputs.forEach(item => {
    item.value = order.name;
  });

  // Also populate hidden order number fields for form submission
  let hiddenOrderInputs = document.querySelectorAll('[id^="hidden-order-number-"]');
  hiddenOrderInputs.forEach(item => {
    item.value = order.name;
  });

  // Update return_to fields in forms to include current order_id
  updateFormReturnUrls();

  // Show success message if form was submitted successfully
  if (formSuccessType) {
    showFormSuccessMessage(formSuccessType);
  }

}

/**
 * Shows success message after form submission
 * @param {string} formType - The type of form ('complaint', 'message', or 'change')
 */
function showFormSuccessMessage(formType) {
  const targetModal = document.querySelector(`[data-form-id="${formType}"]`);

  // Map form types to their success message element IDs
  const successMessageIds = {
    'complaint': 'complaint-form-success-message',
    'message': 'message-success-message',
    'change': 'change-success-message'
  };

  const successMessageId = successMessageIds[formType];
  const successMessage = document.getElementById(successMessageId);

  if (targetModal && successMessage) {
    // Show the modal
    targetModal.classList.add('showPopup');

    // Show the success message
    successMessage.classList.remove('hidden');

    // Hide the form inside the modal
    const form = targetModal.querySelector('form');
    if (form) {
      form.classList.add('hidden');
    }

    // Auto-close after 5 seconds
    setTimeout(() => {
      targetModal.classList.remove('showPopup');
      successMessage.classList.add('hidden');
      if (form) {
        form.classList.remove('hidden');
      }
    }, 5000);
  }
}

async function fetchOrderDetails(orderId, note = null) {
  const orderGid = `gid://shopify/Order/${orderId}`;

  try {
    const response = await fetch('https://us-central1-beauty-rep.cloudfunctions.net/shopifyOrderDetails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        orderGid,
        ...(note && { addNote: note })
      })
    });

    const result = await response.json();

    if (!response.ok) {
      console.error('❌ Server error:', result);
      throw new Error(result.error || 'Failed to fetch order details');
    }

    renderOrderInfo(result.order);
    return result.order;
  } catch (err) {
    console.error('❌ Fetch order failed:', err.message);
    throw err;
  }
}

fetchOrderDetails(orderId);


function renderpopups() {
  const popupTriggers = document.querySelectorAll('[data-form-trigger]');
  const popupForms = document.querySelectorAll('[data-form-id]');
  const allCloseBtns = document.querySelectorAll('.close-modal');


  allCloseBtns.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      if (event.target === event.currentTarget)
        closeAllPopups();
    });
  });

  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      const formId = this.getAttribute('data-form-trigger');
      const targetForm = document.querySelector(`[data-form-id="${formId}"]`);


      if (targetForm) {
        openPopupForm(targetForm);

        populateFormFields(this, targetForm);
      } else {
        console.error(`Form with data-form-id="${formId}" not found`);
      }
    });
  });



  // Close popup when pressing Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllPopups();
    }
  });

  // Note: Forms now use Shopify's native {% form 'contact' %} tag
  // which handles submission automatically with CAPTCHA support.
  // No need to intercept form submissions with JavaScript.

  // Setup photo upload functionality for complaint form
  const dropArea = document.getElementById('photo-drop-area-complaint');
  const fileInput = document.getElementById('photo-upload-complaint');
  const uploadPrompt = document.getElementById('upload-prompt-complaint');
  const filePreview = document.getElementById('file-preview-complaint');
  const removeBtn = document.getElementById('remove-file-complaint');
  const filenameInput = document.getElementById('photo-filename-complaint');
  
  if (dropArea && fileInput) {
    let isProcessing = false;
    
    dropArea.addEventListener('click', (e) => {
      // Only open file picker if we're showing the prompt (no file selected)
      if (!uploadPrompt.classList.contains('hidden') && !isProcessing) {
        fileInput.click();
      }
    });
    
    fileInput.addEventListener('change', function() {
      if (this.files.length > 0 && !isProcessing) {
        isProcessing = true;
        const fileName = this.files[0].name;
        filePreview.querySelector('.file-name').textContent = fileName;
        uploadPrompt.classList.add('hidden');
        filePreview.classList.remove('hidden');
        filenameInput.value = fileName;
        
        // Reset flag after a short delay
        setTimeout(() => {
          isProcessing = false;
        }, 300);
      }
    });
    
    if (removeBtn) {
      removeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        fileInput.value = '';
        filenameInput.value = '';
        uploadPrompt.classList.remove('hidden');
        filePreview.classList.add('hidden');
      });
    }
  }

  /**
   * Opens a specific popup form
   * @param {HTMLElement} formElement - The form element to display
   */
  function openPopupForm(formElement) {
    popupForms.forEach(form => form.classList.remove('showPopup'));

    formElement.classList.add('showPopup');

    setTimeout(() => {
      const firstInput = formElement.querySelector('input:not([readonly]), select, textarea');
      if (firstInput) {
        firstInput.focus();
      }
    }, 100);
  }


  function closeAllPopups() {
    popupForms.forEach(form => {
      form.classList.remove('showPopup');
    });
  }

  /**
   * Populates form fields with data from trigger button
   * @param {HTMLElement} trigger - The button that triggered the popup
   * @param {HTMLElement} form - The form to populate
   */
  function populateFormFields(trigger, form) {


  }

}